import timesheetRedSvg from '@angular/assets/svg/Icons/32/timesheet-red.svg';
import timesheetGreenSvg from '@angular/assets/svg/Icons/32/timesheet-green.svg';
import timesheetYellowSvg from '@angular/assets/svg/Icons/32/timesheet-yellow.svg';

import activityGraySvg from '../assets/svg/Icons/32/activity-gray.svg';
import announcementBlueSvg from '../assets/svg/Icons/32/announcement-blue.svg';
import announcementGraySvg from '../assets/svg/Icons/32/announcement-gray.svg';
import announcementRedSvg from '../assets/svg/Icons/32/announcement-red.svg';
import attachmentBlueSvg from '../assets/svg/Icons/32/attachment-blue.svg';
import attachmentGraySvg from '../assets/svg/Icons/32/attachment-gray.svg';
import birthdayBlueSvg from '../assets/svg/Icons/32/birthday-blue.svg';
import breakYellowSvg from '../assets/svg/Icons/32/break-yellow.svg';
import cogGraySvg from '../assets/svg/Icons/32/cog-gray.svg';
import dashboardBlueSvg from '../assets/svg/Icons/32/dashboard-blue.svg';
import dashboardGraySvg from '../assets/svg/Icons/32/dashboard-gray.svg';
import dashboardRedSvg from '../assets/svg/Icons/32/dashboard-red.svg';
import dateBlueSvg from '../assets/svg/Icons/32/date-blue.svg';
import dateGraySvg from '../assets/svg/Icons/32/date-gray.svg';
import dateRedSvg from '../assets/svg/Icons/32/date-red.svg';
import eventsGraySvg from '../assets/svg/Icons/32/events-gray.svg';
import groupsBlueSvg from '../assets/svg/Icons/32/groups-blue.svg';
import groupsGraySvg from '../assets/svg/Icons/32/groups-gray.svg';
import infoGraySvg from '../assets/svg/Icons/32/info-gray.svg';
import laborGraySvg from '../assets/svg/Icons/32/labor-gray.svg';
import locationBlueSvg from '../assets/svg/Icons/32/location-blue.svg';
import locationGraySvg from '../assets/svg/Icons/32/location-gray.svg';
import logoutGraySvg from '../assets/svg/Icons/32/logout-gray.svg';
import messageBlueSvg from '../assets/svg/Icons/32/message-blue.svg';
import messageGraySvg from '../assets/svg/Icons/32/message-gray.svg';
import newsfeedBlueSvg from '../assets/svg/Icons/32/newsfeed-blue.svg';
import newsfeedGraySvg from '../assets/svg/Icons/32/newsfeed-gray.svg';
import notesBlueSvg from '../assets/svg/Icons/32/notes-blue.svg';
import notesGraySvg from '../assets/svg/Icons/32/notes-gray.svg';
import pagesBlueSvg from '../assets/svg/Icons/32/pages-blue.svg';
import pagesGraySvg from '../assets/svg/Icons/32/pages-gray.svg';
import plusGraySvg from '../assets/svg/Icons/32/plus-gray.svg';
import positionBlueSvg from '../assets/svg/Icons/32/position-blue.svg';
import positionGraySvg from '../assets/svg/Icons/32/position-gray.svg';
import repeatBlueSvg from '../assets/svg/Icons/32/repeat-blue.svg';
import repeatGraySvg from '../assets/svg/Icons/32/repeat-gray.svg';
import settingsBlueSvg from '../assets/svg/Icons/32/settings-blue.svg';
import settingsGraySvg from '../assets/svg/Icons/32/settings-gray.svg';
import shiftAvailableBlueSvg from '../assets/svg/Icons/32/shift-available-blue.svg';
import shiftAvailableGreenSvg from '../assets/svg/Icons/32/shift-available-green.svg';
import shiftAvailableRedSvg from '../assets/svg/Icons/32/shift-available-red.svg';
import shiftAvailableYellowSvg from '../assets/svg/Icons/32/shift-available-yellow.svg';
import shiftBlueSvg from '../assets/svg/Icons/32/shift-blue.svg';
import shiftGraySvg from '../assets/svg/Icons/32/shift-gray.svg';
import shiftGreenSvg from '../assets/svg/Icons/32/shift-green.svg';
import shiftLeaveBlueSvg from '../assets/svg/Icons/32/shift-leave-blue.svg';
import shiftLeaveGraySvg from '../assets/svg/Icons/32/shift-leave-gray.svg';
import shiftLeaveGreenSvg from '../assets/svg/Icons/32/shift-leave-green.svg';
import shiftLeaveRedSvg from '../assets/svg/Icons/32/shift-leave-red.svg';
import shiftOfferBlueSvg from '../assets/svg/Icons/32/shift-offer-blue.svg';
import shiftOfferGreenSvg from '../assets/svg/Icons/32/shift-offer-green.svg';
import shiftOfferRedSvg from '../assets/svg/Icons/32/shift-offer-red.svg';
import shiftOfferYellowSvg from '../assets/svg/Icons/32/shift-offer-yellow.svg';
import shiftRedSvg from '../assets/svg/Icons/32/shift-red.svg';
import shiftWhiteSvg from '../assets/svg/Icons/32/shift-white.svg';
import shiftYellowSvg from '../assets/svg/Icons/32/shift-yellow.svg';
import successGreenSvg from '../assets/svg/Icons/32/success-green.svg';
import taskBlueSvg from '../assets/svg/Icons/32/task-blue.svg';
import taskGraySvg from '../assets/svg/Icons/32/task-gray.svg';
import taskGreenSvg from '../assets/svg/Icons/32/task-green.svg';
import taskRedSvg from '../assets/svg/Icons/32/task-red.svg';
import taskYellowSvg from '../assets/svg/Icons/32/task-yellow.svg';
import timeBlueSvg from '../assets/svg/Icons/32/time-blue.svg';
import timeGraySvg from '../assets/svg/Icons/32/time-gray.svg';
import timeGreenSvg from '../assets/svg/Icons/32/time-green.svg';
import timeRedSvg from '../assets/svg/Icons/32/time-red.svg';
import timeYellowSvg from '../assets/svg/Icons/32/time-yellow.svg';
import userBlueSvg from '../assets/svg/Icons/32/user-blue.svg';
import userGraySvg from '../assets/svg/Icons/32/user-gray.svg';
import shiftSwapBlueSvg from '../assets/svg/Icons/32/shift-swap-blue.svg';
import shiftSwapGraySvg from '../assets/svg/Icons/32/shift-swap-gray.svg';
import shiftSwapGreenSvg from '../assets/svg/Icons/32/shift-swap-green.svg';
import shiftSwapRedSvg from '../assets/svg/Icons/32/shift-swap-red.svg';
import shiftSwapWhiteSvg from '../assets/svg/Icons/32/shift-swap-white.svg';
import shiftSwapYellowSvg from '../assets/svg/Icons/32/shift-swap-yellow.svg';
import pendingYellowSvg from '../assets/svg/Icons/32/pending-yellow.svg';
import documentYellowSvg from '../assets/svg/Icons/32/document-yellow.svg';
import documentRedSvg from '../assets/svg/Icons/32/document-red.svg';

export const SPOTIFY_URL_REGEX = /spotify:track:(\w+)|https:\/\/open.spotify.com\/track\/(\w+)/;
export const ICONS_MAP = {
  'activity-gray': activityGraySvg,
  'announcement-blue': announcementBlueSvg,
  'announcement-gray': announcementGraySvg,
  'announcement-red': announcementRedSvg,
  'attachment-blue': attachmentBlueSvg,
  'attachment-gray': attachmentGraySvg,
  'birthday-blue': birthdayBlueSvg,
  'break-yellow': breakYellowSvg,
  'cog-gray': cogGraySvg,
  'dashboard-blue': dashboardBlueSvg,
  'dashboard-gray': dashboardGraySvg,
  'dashboard-red': dashboardRedSvg,
  'date-blue': dateBlueSvg,
  'date-gray': dateGraySvg,
  'date-red': dateRedSvg,
  'document-yellow': documentYellowSvg,
  'document-red': documentRedSvg,
  'events-gray': eventsGraySvg,
  'groups-blue': groupsBlueSvg,
  'groups-gray': groupsGraySvg,
  'info-gray': infoGraySvg,
  'labor-gray': laborGraySvg,
  'location-blue': locationBlueSvg,
  'location-gray': locationGraySvg,
  'logout-gray': logoutGraySvg,
  'message-blue': messageBlueSvg,
  'message-gray': messageGraySvg,
  'newsfeed-blue': newsfeedBlueSvg,
  'newsfeed-gray': newsfeedGraySvg,
  'notes-blue': notesBlueSvg,
  'notes-gray': notesGraySvg,
  'pages-blue': pagesBlueSvg,
  'pages-gray': pagesGraySvg,
  'plus-gray': plusGraySvg,
  'position-blue': positionBlueSvg,
  'position-gray': positionGraySvg,
  'repeat-blue': repeatBlueSvg,
  'repeat-gray': repeatGraySvg,
  'settings-blue': settingsBlueSvg,
  'settings-gray': settingsGraySvg,
  'shift-available-blue': shiftAvailableBlueSvg,
  'shift-available-green': shiftAvailableGreenSvg,
  'shift-available-red': shiftAvailableRedSvg,
  'shift-available-yellow': shiftAvailableYellowSvg,
  'shift-blue': shiftBlueSvg,
  'shift-gray': shiftGraySvg,
  'shift-green': shiftGreenSvg,
  'shift-leave-blue': shiftLeaveBlueSvg,
  'shift-leave-gray': shiftLeaveGraySvg,
  'shift-leave-green': shiftLeaveGreenSvg,
  'shift-leave-red': shiftLeaveRedSvg,
  'shift-offer-blue': shiftOfferBlueSvg,
  'shift-offer-green': shiftOfferGreenSvg,
  'shift-offer-red': shiftOfferRedSvg,
  'shift-offer-yellow': shiftOfferYellowSvg,
  'shift-red': shiftRedSvg,
  'shift-white': shiftWhiteSvg,
  'shift-yellow': shiftYellowSvg,
  'success-green': successGreenSvg,
  'task-blue': taskBlueSvg,
  'task-gray': taskGraySvg,
  'task-green': taskGreenSvg,
  'task-red': taskRedSvg,
  'task-yellow': taskYellowSvg,
  'time-blue': timeBlueSvg,
  'time-gray': timeGraySvg,
  'time-green': timeGreenSvg,
  'time-red': timeRedSvg,
  'time-yellow': timeYellowSvg,
  'timesheet-yellow': timesheetYellowSvg,
  'timesheet-green': timesheetGreenSvg,
  'timesheet-red': timesheetRedSvg,
  'user-blue': userBlueSvg,
  'user-gray': userGraySvg,
  'shift-swap-blue': shiftSwapBlueSvg,
  'shift-swap-gray': shiftSwapGraySvg,
  'shift-swap-green': shiftSwapGreenSvg,
  'shift-swap-red': shiftSwapRedSvg,
  'shift-swap-white': shiftSwapWhiteSvg,
  'shift-swap-yellow': shiftSwapYellowSvg,
  'pending-yellow': pendingYellowSvg,
};

export const DURATION_OPTIONS_IN_MINUTES = [
  { value: 5, label: '5 minutes' },
  { value: 10, label: '10 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 20, label: '20 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 45, label: '45 minutes' },
  { value: 60, label: '60 minutes' },
  { value: 120, label: '120 minutes' },
  { value: 180, label: '180 minutes' },
];

export const DURATION_OPTIONS_IN_HOURS = [
  { value: 1 },
  { value: 2 },
  { value: 3 },
  { value: 6 },
  { value: 9 },
  { value: 12 },
  { value: 18 },
  { value: 24 },
];
